export default async function GetInvestorOverviewDetails() {
    let url = window.RealestateService+  `/api/InvestorOverviewDetails/GetInvestorOverviewDetails`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}